import { getSmsCode as getCodeHttp } from '@/api/basic';
import { showToast } from 'vant';

type GetCodeParams = {
  userPhone: string; // 手机号
  scene: 1 | 2 | 3 | 4 | 5 | 7; // 发送场景 1：绑定手机号 2：查询报告 3：实名认证 4：登录 5:修改密码 7:进件
  sendPlatform: 1 | 2 | 3 | 4; // 发送端 1：微信小程序 2：APP 3：管理端 4： H5
};
export type GetCodeOpt = { withoutToast?: boolean };

type FnParams = Partial<{
  timer: number;
  request: (data: GetCodeParams) => Promise<any>;
}>;

const getInitConfig = () => ({ timer: 60 } as Required<FnParams>);
export const useSmsCode = (params?: FnParams) => {
  const curConfig = Object.assign(getInitConfig(), params);
  const request = params?.request || getCodeHttp;

  const getInitCodeInfo = () => ({
    codeValue: '', // 验证码的值
    isGetCode: false, // 是否在获取验证码
    codeTime: curConfig.timer, // 下次获取验证码的剩余时间
    tipText: '获取验证码',
  });
  const initCodeInfo = () => {
    timer && clearTimeout(timer);
    timer = 0;
    Object.assign(codeInfo, getInitCodeInfo());
  };
  const codeInfo = reactive(getInitCodeInfo());
  let timer = 0; // 定时器编号

  const getSmsCode = async (data: GetCodeParams, option: GetCodeOpt = {}) => {
    if (timer) return;
    codeInfo.isGetCode = true;
    return request(data)
      .then(() => {
        codeInfo.isGetCode = false;
        if (option.withoutToast) return;
        showToast('发送成功，请注意查收');
        codeInfo.tipText = `${codeInfo.codeTime}秒后获取`;
        timer = window.setInterval(() => {
          if (codeInfo.codeTime > 0) {
            codeInfo.codeTime--;
            codeInfo.tipText = `${codeInfo.codeTime}秒后获取`;
          } else {
            clearInterval(timer);
            codeInfo.codeTime = curConfig.timer;
            timer = 0;
            codeInfo.tipText = '获取验证码';
          }
        }, 1000);
      })
      .catch(() => {
        codeInfo.isGetCode = false;
      });
  };

  return { codeInfo, getSmsCode, initCodeInfo };
};
